import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { get, orderBy } from 'lodash';

import dateFormat from 'dateformat';

import 'react-toastify/dist/ReactToastify.css';

import { displayErrors, formataTelefone } from '../../../util/diversos';
import { fillColumns } from '../../../components/table';
import { Input100px, Input200px } from '../../../styles/inputGroup';

import store from '../../../store/store';
import axiosAdmin from '../../../services/axiosAdmin';
import Card from '../../../components/card';
import Loading from '../../loading';
import CadastroOrcamento from './cadastroOrcamento';
import PdfOrcamento from '../relatorio/pdfOrcamento';

import ConsultaParticipante from '../participante/consultaParticipante';

export default function ConsultaOrcamento({ somenteLeitura = false }) {
  const [isLoading, setIsLoading] = useState(false);

  const [cnpjEmpresa, setCnpjEmpresa] = useState('');

  const [showCadastro, setShowCadastro] = useState(false);
  const [showPrint, setShowPrint] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [dataTableList, setDataTableList] = useState([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [selectedItens, setSelectedItens] = useState(null);
  const [findDataInicial, setFindDataInicial] = useState(null);
  const [findDataFinal, setFindDataFinal] = useState(null);
  const [findNomeOrcamento, setFindNomeOrcamento] = useState('');

  const [findNomeCliente, setFindNomeCliente] = useState('');
  const [findIdCliente, setFindIdCliente] = useState(null);

  const [showConsultaParticipante, setShowConsultaParticipante] = useState(false);

  const [sortField, setSortField] = useState('descricao');
  const [sortOrder, setSortOrder] = useState(null);
  const [payloadCadastro, setPayloadCadastro] = useState({});
  const [payloadPrint, setPayloadPrint] = useState({});

  const [columnsSetup] = useState([
    { field: 'data', header: 'Data', sort: true },
    { field: 'numero', header: 'Número', sort: true },
    { field: 'nomeOrcamento', header: 'Nome do Orçamento', sort: true },
    { field: 'participante.razaoSocial', header: 'Razão Social', sort: false },
    // { field: 'cliente.telefone_1', header: 'Telefone', sort: false },
    { field: 'valorTotal', header: 'Valor do Orçamento', sort: false },
    { field: 'observacao', header: 'Observação', sort: false },
  ]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 0,
    sortField: null,
    sortOrder: null,
    filters: null,
  });

  addLocale('pt-BR', {
    firstDayOfWeek: 0,
    dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'hoje',
    clear: 'Limpar',
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  async function getData(searchFilter, page, size) {
    try {
      setIsLoading(true);

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      let params = `/orcamento/search?idUsuario=${idUsuario}`;

      if (searchFilter && searchFilter.findDataInicial !== '') {
        const _dataInicial = dateFormat(searchFilter.findDataInicial, 'dd-mm-yyyy');
        const _dataFinal = dateFormat(searchFilter.findDataFinal, 'dd-mm-yyyy');

        params = `${params}&dataInicial=${_dataInicial}&dataFinal=${_dataFinal}`;
      }

      if (searchFilter && searchFilter.findNomeOrcamento !== '') {
        params = `${params}&nomeOrcamento=${findNomeOrcamento}`;
      }

      if (searchFilter && searchFilter.findIdCliente > 0) {
        params = `${params}&idParticipante=${findIdCliente}`;
      }

      params = `${params}&page=${page}&size=${size}`;

      const response = await axiosAdmin.get(params);

      setFindNomeOrcamento('');

      const dadosTratados = response.data.content.map(item => ({
        ...item,
        observacao: item.observacao ? item.observacao.substring(0, 30) + '...' : '',
      }));

      setDataTableList(dadosTratados);
      setTotalRecords(response.data.totalElements);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  const handleFind = () => {
    const searchFilter = { findDataInicial, findDataFinal, findNomeOrcamento, findIdCliente };

    const _lazyParams = { ...lazyParams, first: 0, page: 0 };

    setLazyParams(_lazyParams);

    getData(searchFilter, 0, lazyParams.rows);
  };

  async function verificarSeMultiEmpresa(idUsuario) {
    try {
      setIsLoading(true);

      const params = `/usuario/${idUsuario}`;

      const response = await axiosAdmin.get(params);

      const _listaEmpresas = get(response.data, 'listaEmpresas', []);

      const listDropdown = [];
      listDropdown.push({ label: ' Todas', value: 'TODOS' });

      let cnpjPreenchido = false;
      let _cnpjEmpresaStore = get(store.getState().auth, 'cnpjEmpresa', '');

      if (_cnpjEmpresaStore !== null && _cnpjEmpresaStore !== '') {
        setCnpjEmpresa(_cnpjEmpresaStore);
        cnpjPreenchido = true;
      }

      _listaEmpresas.forEach(element => {
        if (!cnpjPreenchido) {
          setCnpjEmpresa(element.cnpj);
          _cnpjEmpresaStore = element.cnpj;
          cnpjPreenchido = true;
        }

        const nomeEmpresa = element.nomeFantasia ? element.nomeFantasia : element.razaoSocial;

        listDropdown.push({ label: nomeEmpresa, value: element.cnpj });
      });

      listDropdown.sort((a, b) => ((a.label > b.label) ? 1 : -1));
    } catch (err) {
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    verificarSeMultiEmpresa(get(store.getState().auth.user, 'id', 0));

    if (findDataInicial === null) {
      setFindDataInicial(new Date(store.getState().auth.consultaEstampariaPedidoDataInicial));
      setFindDataFinal(new Date(store.getState().auth.consultaEstampariaPedidoDataFinal));

      const _dataInicial = new Date(store.getState().auth.consultaEstampariaPedidoDataInicial);
      const _dataFinal = new Date(store.getState().auth.consultaEstampariaPedidoDataFinal);

      const searchFilter = { findDataInicial: _dataInicial, findDataFinal: _dataFinal, cnpjEmpresa};

      verificarSeMultiEmpresa(get(store.getState().auth.user, 'id', 0), searchFilter);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handleRegister = () => {
    const id = 0;

    setPayloadCadastro({ id, cnpjEmpresa });

    setShowCadastro(true);
  };

  const handleEdit = (e) => {
    e.preventDefault();

    const id = get(selectedItens, 'id', 0);

    if (id > 0) {
      setPayloadCadastro({ id, cnpjEmpresa });
      setShowCadastro(true);
    } else {
      toast.warning('Por favor, selecione o registro para edição');
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();

    const id = get(selectedItens, 'id', 0);

    if (id > 0) {
      setShowConfirmDialog(true);
    } else {
      toast.warning('Por favor, selecione o registro para exclusão');
    }
  };

  const cancelDelete = () => {
    setShowConfirmDialog(false);
  };

  const confirmDelete = async () => {
    setShowConfirmDialog(false);

    try {
      setIsLoading(true);

      const idExclusao = get(selectedItens, 'id', 0);

      if (idExclusao > 0) {
        await axiosAdmin.delete(`/orcamento/${idExclusao}`);

        const searchFilter = { findDataInicial, findDataFinal, findNomeOrcamento };

        getData(searchFilter, 0, lazyParams.rows);

        toast.success('Registro excluído com sucesso');
      }
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível excluir o registro');
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDialogFooter = (
    <div>
      <Button label="Sim" icon="pi pi-check" onClick={confirmDelete} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDelete} />
    </div>
  );

  const onSort = (e) => {
    setSortField(e.sortField);
    setSortOrder(e.sortOrder);

    setDataTableList(orderBy(dataTableList, [sortField], [sortOrder]));
  };

  const onPage = (event) => {
    setLazyParams(event);

    const searchFilter = { findDataInicial, findDataFinal, findNomeOrcamento };

    getData(searchFilter, event.page, event.rows);
  };

  const onHideCadastro = () => {
    setShowCadastro(false);
  };

  const childToParentCadastro = (payloadDataTableList, id) => {
    if (payloadDataTableList) {
      if (id > 0) {
        const searchFilter = { findDataInicial, findDataFinal, findNomeOrcamento };

        getData(searchFilter, lazyParams.page, lazyParams.rows);
      } else {
        const _dataTableList = [];
        _dataTableList.push(payloadDataTableList);

        setDataTableList(_dataTableList);

        const _lazyParams = { ...lazyParams, first: 0, page: 0 };
        setLazyParams(_lazyParams);
        setTotalRecords(1);
      }
    }

    setShowCadastro(false);
  };

  const handlePrint = (e) => {
    e.preventDefault();

    const id = get(selectedItens, 'id', 0);

    if (id > 0) {
      setPayloadPrint({ id });
      setShowPrint(true);
    } else {
      toast.warning('Por favor, selecione o registro para edição');
    }
  };

  const onHidePrint = () => {
    setShowPrint(false);
  };

  const finishPrintOrcamento = () => {
    setShowPrint(false);
  };

  const onHideConsultaParticipante = () => {
    setShowConsultaParticipante(false);
  };

  const childToParentParticipante = (e) => {
    const idElement = get(e, 'id', 0);

    if (idElement > 0) {
      if (e.id) {
        setFindIdCliente(e.id);
      }
      if (e.razaoSocial) {
        setFindNomeCliente(e.razaoSocial);
      }
      setShowConsultaParticipante(false);
    } else {
      toast.warning('Por favor, selecione o registro');
    }
  };

  const limparParticipanteSelecionado = () => {
    setFindIdCliente(null);
    setFindNomeCliente('');
    toast.info('Cliente selecionado removido.');
  };

  return (
    <>
      <Loading isLoading={isLoading} />

      <Dialog
        header=""
        closeOnEscape={false}
        visible={showCadastro}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastro()}
        className="dialog-cadastro"
      >
        <CadastroOrcamento payloadCadastro={payloadCadastro} childToParentCadastro={childToParentCadastro} />
      </Dialog>

      <Dialog
        header=""
        visible={showPrint}
        style={{ width: '98vw' }}
        onHide={() => onHidePrint()}
        className="dialog-cadastro"
      >
        <PdfOrcamento payloadPrint={payloadPrint} finishPrintOrcamento={finishPrintOrcamento} />
      </Dialog>

      <Card>
        <div>
          <div className="card mb-3">
            <h6 className="card-header" style={{ textAlign: 'center' }}>
              ORÇAMENTOS
            </h6>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-3">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Data inicial
                </Input100px>
                <Calendar
                  id="mask"
                  showIcon
                  mask="99/99/9999"
                  dateFormat="dd/mm/yy"
                  showButtonBar
                  showOnFocus={false}
                  locale="pt-BR"
                  value={findDataInicial}
                  onChange={(e) => { setFindDataInicial(e.value); }}
                />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Data final
                </Input100px>
                <Calendar
                  id="mask"
                  showIcon
                  mask="99/99/9999"
                  dateFormat="dd/mm/yy"
                  showButtonBar
                  showOnFocus={false}
                  locale="pt-BR"
                  value={findDataFinal}
                  onChange={(e) => { setFindDataFinal(e.value); }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <button
                type="button"
                title="Buscar"
                className="btn btn-success"
                style={{ borderRadius: '15px' }}
                onClick={handleFind}
              >
                <i className="pi pi-search"></i>
              </button>
              <button
                disabled={somenteLeitura}
                type="button"
                title="Cadastrar"
                className="btn btn-primary"
                style={{ borderRadius: '15px' }}
                onClick={handleRegister}
              >
                <i className="pi pi-plus"></i>
              </button>
              <button
                disabled={somenteLeitura}
                type="button"
                title="Editar"
                className="btn btn-warning"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleEdit(e)}
              >
                <i className="pi pi-pencil"></i>
              </button>
              <button
                disabled={somenteLeitura}
                type="button"
                title="Excluir"
                className="btn btn-danger"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleDelete(e)}
              >
                <i className="pi pi-trash"></i>
              </button>
              <button
                type="button"
                title="Imprimir Orçamento"
                className="btn btn-dark"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handlePrint(e)}
              >
                <i className="pi pi-eye"></i>
              </button>
            </div>
          </div>
          <br />
          <div className="row align-items-center">
            <div className="col-6">
              <div className="p-inputgroup">
                <Input200px className="p-inputgroup-addon">
                  Nome do Orçamento
                </Input200px>
                <InputText
                  maxLength={100}
                  value={findNomeOrcamento}
                  onChange={e => setFindNomeOrcamento(e.target.value)}
                  onKeyDown={async (e) => {
                    if (e.code === 'Enter' || e.code === 'NumpadEnter') {
                      handleFind(e.target.value);
                    }
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Cliente
                </Input100px>
                <InputText
                  disabled
                  maxLength={255}
                  value={findNomeCliente}
                  onChange={e => setFindNomeCliente(e.target.value)}
                />
                <Button
                  icon="pi pi-search"
                  className="p-button-warning"
                  onClick={() => setShowConsultaParticipante(true)}
                />
                <Button
                  icon="pi pi-times"
                  title="Remover seleção"
                  className="p-button-danger"
                  onClick={() => limparParticipanteSelecionado()}
                />
              </div>
            </div>
          </div>
          <div className="row align-items-center" style={{ marginTop: '10px' }}>
          </div>
        </div>
        <br />

        <div className="card">
          <DataTable
            value={dataTableList}
            size="small"
            stripedRows
            responsiveLayout="scroll"
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSort}
            selectionMode="single"
            selection={selectedItens}
            onSelectionChange={e => setSelectedItens(e.value)}
            selectableRows
            dataKey="id"
            paginator
            lazy
            first={lazyParams.first}
            rows={lazyParams.rows}
            totalRecords={totalRecords}
            onPage={onPage}
            emptyMessage="Nenhum registro a ser exibido"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="{currentPage} de {totalPages}"
            rowsPerPageOptions={[10, 25, 50]}
          >
            {fillColumns(columnsSetup)}
          </DataTable>
        </div>

        <Dialog
          header="Consulta de Participantes"
          visible={showConsultaParticipante}
          style={{ width: '98vw' }}
          onHide={() => onHideConsultaParticipante()}
        >
          <ConsultaParticipante menuMode={false} childToParent={childToParentParticipante} />
        </Dialog>

        <Dialog
          header="Confirmação"
          visible={showConfirmDialog}
          style={{ width: '50vw' }}
          footer={confirmDialogFooter}
          onHide={() => setShowConfirmDialog(false)}
        >
          <p>
            Excluir o registro?
          </p>
        </Dialog>
      </Card>
    </>
  );
}
